"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createWorkflows = exports.CreateWorkflows = exports.CreateWorkflowsActionTypes = exports.fetchWorkflowsExistence = exports.FetchWorkflowsExistence = exports.FetchWorkflowsExistenceActionTypes = exports.QuoteApprovalActionTypes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _actions = require("settings-ui-lib/utils/actions");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-lib/constants/RequestStatusTypes"));

var _fluxActions = require("flux-actions");

var _identity = _interopRequireDefault(require("transmute/identity"));

var QuoteApprovalActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_WORKFLOWS_EXISTENCE: null,
  CREATE_WORKFLOWS: null
}, 'quoteApproval');
exports.QuoteApprovalActionTypes = QuoteApprovalActionTypes;
var FetchWorkflowsExistenceActionTypes = (0, _actions.createRequestTypes)(QuoteApprovalActionTypes.FETCH_WORKFLOWS_EXISTENCE);
exports.FetchWorkflowsExistenceActionTypes = FetchWorkflowsExistenceActionTypes;
var FetchWorkflowsExistence = (0, _actions.createRequestActions)(FetchWorkflowsExistenceActionTypes);
exports.FetchWorkflowsExistence = FetchWorkflowsExistence;
var fetchWorkflowsExistence = (0, _fluxActions.createAction)(QuoteApprovalActionTypes.FETCH_WORKFLOWS_EXISTENCE);
exports.fetchWorkflowsExistence = fetchWorkflowsExistence;
var CreateWorkflowsActionTypes = (0, _actions.createRequestTypes)(QuoteApprovalActionTypes.CREATE_WORKFLOWS);
exports.CreateWorkflowsActionTypes = CreateWorkflowsActionTypes;
var CreateWorkflows = (0, _actions.createRequestActions)(CreateWorkflowsActionTypes, {
  successMetaCreator: function successMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(CreateWorkflowsActionTypes.base, _RequestStatusTypes.default.SUCCEEDED), (0, _actions.createSuccessNotificationMeta)(_react.default.createElement(_FormattedMessage.default, {
      message: "sales.quoteApproval.createWorkflows.success"
    })));
  },
  failureMetaCreator: function failureMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(CreateWorkflowsActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_react.default.createElement(_FormattedMessage.default, {
      message: "sales.quoteApproval.createWorkflows.failure"
    })));
  }
});
exports.CreateWorkflows = CreateWorkflows;
var createWorkflows = (0, _fluxActions.createAction)(QuoteApprovalActionTypes.CREATE_WORKFLOWS, _identity.default);
exports.createWorkflows = createWorkflows;